import React, { useState } from 'react';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import toast, { Toaster } from 'react-hot-toast';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;

        setError(null);

        setLoading(true);

        try {
            const userCred = await signInWithEmailAndPassword(auth, email, password);
            if (userCred) {
                navigate('/'); 
            }
        } catch (err) {
            setError('Invalid Credentials');
        } finally {
            setLoading(false);
        }
    };

    // Styles as JS objects
    const styles = {
        loginContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            padding: '20px',
            boxSizing: 'border-box',
            margin: 0,
        },
        loginForm: {
            backgroundColor: 'rgb(19, 67, 19)',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)',
            width: '100%',
            maxWidth: '400px',
            color: '#d7d5d5',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        },
        heading: {
            marginBottom: '20px',
            textAlign: 'center',
        },
        formGroup: {
            marginBottom: '15px',
        },
        label: {
            display: 'block',
            marginBottom: '6px',
            fontWeight: 500,
        },
        input: {
            width: '100%',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxSizing: 'border-box',
        },
        button: {
            width: '100%',
            padding: '12px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: 'pointer',
        },
        buttonHover: {
            backgroundColor: '#45a049',
        },
        errorText: {
            color: 'red',
            marginTop: '10px',
        },
    };

    const [hover, setHover] = useState(false);

    return (
        <div style={styles.loginContainer}>

            <Toaster />
            <form style={styles.loginForm} onSubmit={handleSubmit}>
                <h2 style={styles.heading}>Knock Deliver Login</h2>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={styles.input}
                    />
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={styles.input}
                    />
                </div>

                <button
                    type="submit"
                    style={hover ? { ...styles.button, ...styles.buttonHover } : styles.button}
                    onMouseEnter={() => setHover(true)}
                    onMouseLeave={() => setHover(false)}
                >
                    {loading ? <ProgressSpinner style={{ width: '25px', height: '25px' }} /> : 'Login'}
                </button>

                {error && <p style={styles.errorText}>{error}</p>}
            </form>
        </div>
    );
}
